import version from "@/config/version";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../primitives/dropdown-menu";
import { AccountMenuItem } from "./AccountMenuItem";

export default function AccountMenuDropdown({
  items,
  trigger,
}: {
  items: AccountMenuItem[];
  trigger: React.ReactNode;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex self-center">
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="right"
        className="mb-5 ml-1 flex flex-col gap-0 rounded-lg p-2 shadow-md"
      >
        {items.map(({ label, icon, onClick }) => (
          <DropdownMenuItem
            key={label}
            className="flex items-center text-sm"
            onClick={onClick}
          >
            {icon}
            {label}
          </DropdownMenuItem>
        ))}
        <code className="pt-1 text-center text-xs text-foreground/30">
          {version}
        </code>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
